@if (initialized && formGroup && otpFormControl) {
  <div class="auth-container p-4">
    <div class="login-box">
      <div class="surface-card sm:p-2 p-1 shadow-2 border-round-2xl w-full">
        <form class="flex flex-column w-full mt-4 sm:px-3 px-1" [formGroup]="formGroup">
          <div class="flex justify-content-center mb-5">
        <span class="w-6rem h-6rem border-circle flex justify-content-center align-items-center bg-orange-50">
          <i class="pi pi-lock text-orange-600 text-5xl"></i>
        </span>
          </div>
          <div class="mb-5">
            <p class="font-semibold text-3xl mt-0 mb-2 text-color text-center">Überprüfung</p>
            <p class="text-center mt-0 mb-3 text-color-secondary text-center">
              {{
                isLoginOtpFlow ?
                  logInFlowStatusMessage :
                  'Wir haben einen Sicherheitscode an folgende Nummer gesendet:'
              }}
              <span class="text-color font-medium">{{ hiddenUserText }}</span></p>
          </div>
          <div class="flex justify-content-center w-full align-items-center gap-2">
            <ng-otp-input
              [formCtrl]="otpFormControl"
              allowNumbersOnly="true"
              [config]="ngOtpConfig"
              inputClass="md:w-4rem w-3rem text-center"
              spellcheck="false"
              inputmode="numeric"
              [class.otp-invalid]="errorMessage"
            >
            </ng-otp-input>


          </div>

          <div class="flex flex-column gap-4 my-3">
            <!--invalid opt code message warning-->
            <p-message *ngIf="errorMessage" severity="error" text="{{errorMessage}}" styleClass="block text-left"
                       [ngStyle]="{'word-break': 'break-word'}"></p-message>
            <p-message hideTransitionOptions="500ms" *ngIf="otpRequestMessage" severity="success"
                       text="{{otpRequestMessage}}" styleClass="block text-left"
                       [ngStyle]="{'word-break': 'break-word'}">
            </p-message>
            <app-button
              [busy]="busy"
              [disabled]="!formGroup.valid || confirmOtpBusy"
              [type]="'submit'"
              label="{{isLoginOtpFlow ? 'Weiter mit Einmalpasswort' : 'Code überprüfen'}}"
              [class]="'w-full'"
              [showIcon]="false"
              (onClick)="handleOtp()">
            </app-button>
            @if(isLoginOtpFlow){
              <div class="flex justify-content-center">
                <app-button
                  [label]="backButtonText"
                  [class]="'p-button-text'"
                  [showIcon]="true"
                  [iconPos]="'left'"
                  [icon]="'pi pi-arrow-left'"
                  (onClick)="navigateBack()">
                </app-button>
              </div>
            }
          </div>

          <div class="flex flex-column my-3 gap-2 text-center">
            <span class="text-color-secondary d-block">Kein Einmalpasswort erhalten?</span>
            <span class="text-color-secondary">{{countdown > 0 ? countdownLabel : 'Bitte überprüfe deine Eingaben oder wähle:' }}</span>
            <app-button
              [busy]="requestOtpBusy"
              [disabled]="confirmOtpBusy || requestOtpBusy || countdown > 0"
              [label]="'Erneut senden'"
              [class]="'w-full p-button-text'"
              [showIcon]="false"
              (onClick)="handleRequestOtp()">
            </app-button>
            @if (isLoginOtpFlow) {
              <span class="text-color-secondary">Solltest du weiterhin kein Einmalpasswort erhalten, melde dich gerne per WhatsApp bei uns unter 040 5555 18 111.</span>
            }
          </div>
        </form>
      </div>
    </div>
  </div>
}
